import { render, staticRenderFns } from "./CharityDonationDetailsView.vue?vue&type=template&id=6d85e0cb&scoped=true"
import script from "./CharityDonationDetailsView.vue?vue&type=script&lang=js"
export * from "./CharityDonationDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CharityDonationDetailsView.vue?vue&type=style&index=0&id=6d85e0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85e0cb",
  null
  
)

export default component.exports